var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"countdown",attrs:{"data-cy":"luck-offer-countdown"}},[_c('span',[_vm._v("L'offre se termine dans :")]),_c('span',[_vm._v(_vm._s(_vm.luckOfferCountdown))])])
}
var staticRenderFns = []

export { render, staticRenderFns }